import { render, staticRenderFns } from "./GBrandTop.vue?vue&type=template&id=1c4ec4d0&scoped=true&"
import script from "./GBrandTop.vue?vue&type=script&lang=ts&"
export * from "./GBrandTop.vue?vue&type=script&lang=ts&"
import style0 from "./GBrandTop.vue?vue&type=style&index=0&id=1c4ec4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ec4d0",
  null
  
)

export default component.exports